import { UserSubscriptionsList } from './UserSubscriptionsList';

export default {
    list: UserSubscriptionsList,
};